import { Badge, LegacyStack, Text } from '@shopify/polaris';
import { Handle, Position } from 'reactflow';

function TagNode({ id, data }) {

    return (
        <div className="tag-node" onClick={() => data.clickNode(id)}>
            <Handle type="target" position={Position.Left} />
            <br />
            <LegacyStack alignment="center">
                <Text variant="bodySm">
                    Add tag
                </Text>
                {data.tag &&
                    <Badge status="attention">{data.tag}</Badge>
                }
            </LegacyStack>
            <br />
            <Handle type="source" position={Position.Right} />
        </div>
    );
}

export default TagNode;
